import React, { ReactNode } from 'react';
import { Box, Button, Tooltip } from '@mui/material';

import { getChainIdByEnv } from 'modules/api';
import { currentEnv } from 'modules/common';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { globalTranslation, useTranslation } from 'modules/i18n';

import { useConnection } from '../../hooks/useConnection';

interface IWalletConnectGuardProps {
  children: ReactNode;
}

export function WalletConnectGuard({ children }: IWalletConnectGuardProps) {
  const { t, keys } = useTranslation(globalTranslation);
  const { onOpen } = useDialog(KnownDialogs.connect);

  const { isConnected, isLoading, data } = useConnection();

  if (!isConnected) {
    return (
      <Button
        fullWidth
        color="primary"
        disabled={isLoading}
        size="large"
        onClick={onOpen}
      >
        {t(keys.common.connectWallet)}
      </Button>
    );
  }

  if (data?.chainId !== getChainIdByEnv(currentEnv)) {
    return (
      <Tooltip
        title={t(keys.common.unsupportedNetworkTooltip, {
          network: t(
            keys.chains[
              getChainIdByEnv(currentEnv) as keyof typeof keys.chains
            ],
          ),
        })}
      >
        <Box sx={{ width: '100%' }}>
          <Button disabled fullWidth color="primary" size="large">
            {t(keys.common.unsupportedNetwork)}
          </Button>
        </Box>
      </Tooltip>
    );
  }

  return children;
}
